import { render, staticRenderFns } from "./ModalFamily.vue?vue&type=template&id=53fba782&"
import script from "./ModalFamily.vue?vue&type=script&lang=js&"
export * from "./ModalFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports